// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function partner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var mobile = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
    if (mobile.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                mobile: mobile._0
              }
            };
    }
    var e = mobile._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mobile" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function vehicle_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
  if (vehicle_type.TAG === /* Ok */0) {
    var registration_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "registration_number"), null));
    if (registration_number.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                vehicle_type: vehicle_type._0,
                registration_number: registration_number._0
              }
            };
    }
    var e = registration_number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".registration_number" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = vehicle_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function order_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var order_date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_date"), null));
    if (order_date.TAG === /* Ok */0) {
      var order_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_time"), null));
      if (order_time.TAG === /* Ok */0) {
        var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
        if (status.TAG === /* Ok */0) {
          var vehicle = vehicle_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle"), null));
          if (vehicle.TAG === /* Ok */0) {
            var partner = partner_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner"), null));
            if (partner.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        order_id: order_id._0,
                        order_date: order_date._0,
                        order_time: order_time._0,
                        status: status._0,
                        vehicle: vehicle._0,
                        partner: partner._0
                      }
                    };
            }
            var e = partner._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".partner" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = vehicle._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".vehicle" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = status._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".status" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = order_time._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".order_time" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = order_date._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_date" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function result_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var last_date_timestamp = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_date_timestamp"), null));
  if (last_date_timestamp.TAG === /* Ok */0) {
    var order = Decco.listFromJson(order_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order"), null));
    if (order.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                last_date_timestamp: last_date_timestamp._0,
                order: order._0
              }
            };
    }
    var e = order._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = last_date_timestamp._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".last_date_timestamp" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var result = result_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "result"), null));
  if (result.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              result: result._0
            }
          };
  }
  var e = result._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".result" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  partner_decode ,
  vehicle_decode ,
  order_decode ,
  result_decode ,
  t_decode ,
  
}
/* No side effect */
